/**
 * Hooks de **lectura** del dominio Inventario (TanStack Query).
 *
 * Datos de servidor -> TanStack Query (`docs/frontend_conventions.md`, Datos): no
 * `useState`+`useEffect`+`fetch`. La red la gobierna `lib/api` (cookie httpOnly +
 * `X-Sede-Id`). Los rollos se cachean por sede activa (en la key) para recargarse
 * al cambiar de sede; el overview admin es global (key sin sede).
 */
import { useQuery } from "@tanstack/react-query";

import { getActiveSedeId } from "@/lib/sede";

import { fetchAdminOverview, fetchRollos } from "../api";
import type { AdminOverview, RollosData } from "../types";
import { ADMIN_OVERVIEW_KEY, rollosQueryKey } from "./queryKeys";

/** Margen corto: el inventario cambia con altas/consumos, sin refetch agresivo. */
const STALE_TIME = 15_000;

/** Rollos (galv/acero + historial) de la sede activa (`GET /inventario/rollos`). */
export function useRollos() {
  const sedeId = getActiveSedeId();
  return useQuery<RollosData>({
    queryKey: rollosQueryKey(sedeId),
    queryFn: fetchRollos,
    staleTime: STALE_TIME,
  });
}

/** Overview de activación por sede (`GET /inventario/admin`, global, solo admin). */
export function useAdminOverview() {
  return useQuery<AdminOverview>({
    queryKey: ADMIN_OVERVIEW_KEY,
    queryFn: fetchAdminOverview,
    staleTime: STALE_TIME,
  });
}
